<template>
  <div class="pt-4 px-4 pb-20">
    <div class="mb-5">
      <h1 class="text-3xl font-bold">
        {{ $t('statistics') }}
      </h1>
    </div>

    <div class="block">
      <nav class="grid grid-cols-4 space-x-4 mb-5 bg-white rounded-full p-1" :class="[$theme.tabsContainerBg]" aria-label="Tabs">
        <a
            v-for="tab in tabs"
            :key="tab.key"
            href="javascript:void(0)"
            :class="[
              tab.key === activePeriod ? `m-yellow-bg text-black` : `${$theme.tabTextColor}`,
              'rounded-full px-3 py-2 text-sm font-medium text-center'
            ]"
            @click="onChangePeriod(tab.key)"
        >{{ tab.name }}</a>
      </nav>
    </div>

    <template v-if="loading">
      <div class="rounded-xl overflow-hidden" :class="[$theme.cardBg]">
        <LoadingBlock />
      </div>
    </template>
    
    <template v-else>
      <RefStatsChart :ref_stats="stats" />
      <div class="rounded-xl overflow-hidden border" :class="[$theme.cardBg, $theme.borderBlockColor]">
        <dl class="mx-auto grid gap-px grid-cols-2">
          <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-3">
            <dt class="text-sm" :class="[$theme.cardLabelTextColor]">
              {{ $t('income') }}
            </dt>
            <dd
                class="w-full flex-none text-xl font-medium tracking-tight"
                :class="[$theme.baseTextColor]"
            >
              ${{ stats.total.referral_income }}
            </dd>
          </div>
          <div 
            class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-3 border-l"
            :class="[$theme.borderBlockColor]"
          >
            <dt class="text-sm" :class="[$theme.cardLabelTextColor]">{{ $t('referrals') }}</dt>
            <dd class="w-full flex-none text-xl font-medium tracking-tight" :class="[$theme.baseTextColor]">
              {{ stats.total.referrals }}
            </dd>
          </div>
        </dl>
        <RefStatDetails :details="stats.total.details" />
      </div>

      <template v-if="stats.campaigns.length > 0">
        <div v-for="(campaign, campaignIndex) in stats.campaigns" :key="campaignIndex" class="mt-4">
          <div class="mb-1 flex font-medium items-center justify-between">
            {{ campaign.title }}
          </div>
          <div class="rounded-xl overflow-hidden border" :class="[$theme.cardBg, $theme.borderBlockColor]">
            <dl class="mx-auto grid gap-px grid-cols-2">
              <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-3">
                <dt class="text-sm font-medium" :class="[$theme.cardLabelTextColor]">
                  {{ $t('income') }}
                </dt>
                <dd
                    class="w-full flex-none text-xl font-medium tracking-tight"
                    :class="[campaign.referral_income < 0 ? $theme.dangerPnlColor : $theme.successPnlColor]"
                >
                  ${{ campaign.referral_income }}
                </dd>
              </div>
              <div class="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 px-3 py-3">
                <dt class="text-sm font-medium" :class="[$theme.cardLabelTextColor]">{{ $t('referrals') }}</dt>
                <dd class="w-full flex-none text-xl font-medium tracking-tight" :class="[$theme.baseTextColor]">
                  {{ campaign.referrals }}
                </dd>
              </div>
            </dl>
            <RefStatDetails :details="campaign.details" />
          </div>
        </div>
      </template>

      <div v-if="ref_stats && ref_stats.levels" class="mt-5">
        <div class="mb-2 flex items-center justify-between">
          {{ $t('stats_by_levels') }}
        </div>
        <div class="grid grid-cols-3 gap-2">
          <div v-for="ref_stats in ref_stats.levels" :key="ref_stats.level" class="text-sm rounded-xl overflow-hidden p-3 border" :class="[$theme.cardBg, $theme.borderBlockColor]">
            <div>
              <span :class="[$theme.activeTabBg, $theme.activeTabTextColor, 'px-1 py-0.5 rounded-md text-xs']">{{ ref_stats.percentage }}%</span>
            </div>
            <div class="mt-1">
              {{ $t('level') }} {{ ref_stats.level }}
            </div>
            <div class="font-bold text-xl">{{ ref_stats.referrals_count }}</div>
            <div class="mt-1 font-bold">{{ formattedAmount(ref_stats.income) }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LoadingBlock from "@/components/LoadingBlock.vue";
import RefStatDetails from "@/components/elem/RefStatDetails.vue";
import RefStatsChart from "@/components/elem/RefStatsChart.vue";
import {addBackButton, hideBackButton} from "@/helpers/telegramHelper";
import {formattedAmount} from "@/helpers/numberHelper";

export default {
  components: {
    LoadingBlock,
    RefStatDetails,
    RefStatsChart,
  },

  methods: {
    loadStats() {
      this.loading = true;

      this.$api.get(`/stats/refs?period=${this.activePeriod}`).then((result) => {
        console.log('result', result);
        this.stats = result.data;
        this.loading = false;
      });
    },

    onChangePeriod(period) {
      this.activePeriod = period;

      this.loadStats();
    },
  },

  data() {
    return {
      activePeriod: '7days',
      tabs: [
        {
          name: this.$t('7days'),
          key: '7days',
        },
        {
          name: this.$t('14days'),
          key: '14days',
        },
        {
          name: this.$t('30days'),
          key: 'month',
        },
        {
          name: this.$t('year'),
          key: 'year',
        },
      ],

      loading: true,

      stats: null,

      ref_stats: this.$user.ref_stats,

      formattedAmount
    }
  },

  mounted() {
    this.loadStats();

    console.log(this.$user.ref_stats)

    addBackButton(this.$router);
  },

  beforeUnmount() {
    hideBackButton();
  }
};
</script>